module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOSAxOSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+U2VhcmNoPC90aXRsZT48cGF0aCBkPSJNMTguMTEgMTYuNDc2bC00LjI2My00LjI2NGMtLjEtLjEtLjIyNC0uMTYzLS4zNDUtLjIzYTcuMzkgNy4zOSAwIDEgMC0xLjk3MyAxLjk3M2MuMDY1LjEyMy4xMjYuMjQ2LjIzLjM0OGw0LjI2IDQuMjY0YTEuNDc4IDEuNDc4IDAgMCAwIDIuMDktMi4wOXpNNy4zODQgMTMuMjU4YTUuNDIgNS40MiAwIDEgMSAuMDAyLTEwLjg0IDUuNDIgNS40MiAwIDAgMS0uMDAyIDEwLjg0eiIgZmlsbD0iI0NDQyIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/magnifying-glass-icon.svg
// module id = xjUl
// module chunks = 89